<template>
  <HistoryChangeTable
    ref="table"
    :endpoint="`v2/transaction-histories/by-transaction/${transactionId}`"
    :action-options="actionOptions"
    :no-change-text="messages.NO_CHANGE"
    :no-match-text="messages.NO_MATCH"
    :invalid-date-range-text="messages.INVALID_DATE_RANGE"
    :on-error="onError"
    :action-label="actionLabel"
    :limit="PAGE_LIMIT"
    @show-detail="showDetail"
  >
    <b-modal
      v-model="detailVisible"
      title="Chi tiết thay đổi"
      size="lg"
      hide-footer
      scrollable
      no-fade
    >
      <dl v-if="detailItem" class="row mb-3">
        <dt class="col-5 col-md-3">Hành động</dt>
        <dd class="col-7 col-md-9">{{ actionLabel(detailItem) }}</dd>
        <dt class="col-5 col-md-3">Người thực hiện</dt>
        <dd class="col-7 col-md-9">{{ detailItem.updatedByName || '—' }}</dd>
        <dt class="col-5 col-md-3">Thời gian</dt>
        <dd class="col-7 col-md-9">{{ formatTime(detailItem.createdAt) }}</dd>
      </dl>
      <b-table
        v-if="detailItem && detailItem.diffValues.length"
        :items="detailItem.diffValues"
        :fields="detailFields"
        bordered
        small
        responsive
      >
        <template #cell(originalValue)="{ value }">
          <span class="text-break">{{ value }}</span>
        </template>
        <template #cell(newValue)="{ value }">
          <span class="text-break">{{ value }}</span>
        </template>
      </b-table>
      <p v-else-if="detailItem" class="text-center text-muted mb-0">
        {{ messages.NO_VISIBLE_CHANGE }}
      </p>
    </b-modal>
  </HistoryChangeTable>
</template>

<script>
import { formatDate } from '@/utils/common';
import {
  HISTORY_TIME_FORMAT,
  TRANSACTION_HISTORY_ACTION_OPTIONS,
  TRANSACTION_HISTORY_MESSAGES,
} from '@/utils/constants';
import HistoryChangeTable from '@/view/components/history/HistoryChangeTable.vue';
import { toastHistoryError } from '@/view/components/history/history-error';

const PAGE_LIMIT = 5;

export default {
  name: 'TransactionChangeHistory',
  components: { HistoryChangeTable },
  props: {
    transactionId: { type: [Number, String], required: true },
  },
  data() {
    return {
      PAGE_LIMIT,
      actionOptions: TRANSACTION_HISTORY_ACTION_OPTIONS,
      messages: TRANSACTION_HISTORY_MESSAGES,
      detailVisible: false,
      detailItem: null,
      detailFields: [
        { key: 'keyName', label: 'Thông tin', thStyle: { width: '20%' } },
        { key: 'originalValue', label: 'Trước', thStyle: { width: '40%' } },
        { key: 'newValue', label: 'Sau', thStyle: { width: '40%' } },
      ],
    };
  },
  methods: {
    // API trả sẵn nhãn đủ nghĩa ("Sửa phiếu", "Tạo phiếu (dữ liệu trước khi có lịch sử)")
    actionLabel(item) {
      return item ? item.actionName : '';
    },
    formatTime(value) {
      return formatDate(value, HISTORY_TIME_FORMAT) || '';
    },
    onError(error) {
      toastHistoryError(
        error,
        this.messages.FORBIDDEN,
        this.messages.LOAD_FAILED,
      );
    },
    showDetail(item) {
      this.detailItem = item;
      this.detailVisible = true;
    },
    // Tải lại trang đang xem, giữ bộ lọc đã áp dụng
    reload() {
      this.$refs.table.fetchData();
    },
  },
};
</script>
